module.exports = __webpack_public_path__ + "65d48591c1e4c2bdd13128a7d6ed9a1e.svg";